/* eslint-disable arrow-parens */
import './vendor';
import vars from './helpers';
import './components/analytics';
import './components/social';
import {ieFix} from './vendor/ie-fix';
import {vhFix} from './vendor/vh-fix';
import {actualYear} from './modules/actualYear';
import './modules/headerMenu';
import header from './components/header';
import popup from './components/popup';
import scrollbar from './components/scrollbar';
import cookies from './components/cookies';
import request from './components/request';
import requestSimple from './components/request-simple';
import lazyLoading from './modules/lazyLoading';
// import map from './components/map';
import sliders from './components/sliders';
import dropdown from './components/dropdown';
import showmore from './components/showmore';
import scrollToAnchor from './modules/scrollToAnchor';
import backBtn from './components/backBtn';
// import {pages} from './db/pages';
import {service} from './db/service';
import {Search} from './components/Search';
import requestInfoshop from './components/request-infoshop';
// import brandPage from './components/brandPage';
import accordion from './components/accordion';
import whiteLabel from './components/white-label';
import state from './components/state';
import webpush from './components/webpush';

window.whiteLabel = null;
ieFix();
vhFix();
actualYear();
let initScrollBar = false;
const headerSearch = document.querySelector('.header__search');
if (headerSearch) {
	const search = new Search(service, 'header-result', 'homeSearch');
	search.init();
}

const serviceSearch = document.querySelector('.service__search');
if (serviceSearch) {
	const search = new Search(service, 'service-result', 'serviceSearch');
	search.init();
}

if (!vars.isMobile()) {
	scrollbar.init();
	initScrollBar = true;
} else {
	header.init();
}

window.addEventListener('resize', () => {
	if (!vars.isMobile() && !initScrollBar) {
		scrollbar.init();
		initScrollBar = true;
	} else if (vars.isMobile() && vars.$header[0]) {
		vars.$header.css('top', '0px');
		initScrollBar = false;
	}
});

if (document.querySelector('.black-f__button')) {
	document.querySelector('.black-f__button').addEventListener('click', () => {
		const newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?utm_content=black_friday';
		window.history.pushState({path: newurl}, '', newurl);
		// window.history.search = 'utm_content=black_friday'
	});
}
webpush.init();
state.init();
whiteLabel.init();
cookies.init();
request.init();
requestInfoshop.init();
requestSimple.init();
lazyLoading.init();
sliders.init();
dropdown.init();
showmore.init();
popup.init();
scrollToAnchor.init();
backBtn.init();
accordion.init();
// brandPage.init();
